export default "__VITE_ASSET__CANGn9HJ__"